// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconCashPlus = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M2 19V5h20v6h-2V9h-2V7H6v2H4v6h2v2h7v2z" />,
    <path d="M13 14.83a3 3 0 11-2-5.658 3 3 0 012 5.657M18 18v3h2v-3h3v-2h-3v-3h-2v3h-3v2z" />
  );
export default SvgIconCashPlus;
